import { PropsWithChildren } from 'react';

import { Paragraph } from '@vimeo/iris/typography';

import Container from './Container';
import {
  Description,
  Divider,
  SectionHeader,
  SectionTextWrapper,
  TitleWrapper,
  FeatureStackContentWrapper,
} from './index.styles';

interface StackContentProps {
  isFirst?: boolean;
  title: string;
  descriptions: Array<string>;
}

const StackContent: React.FC<StackContentProps & PropsWithChildren> = ({
  children,
  isFirst,
  title,
  descriptions,
}) => {
  return (
    <Container>
      <FeatureStackContentWrapper>
        <div style={{ width: '75%' }}>{children}</div>
        <div style={{ width: '50%' }}>
          <SectionTextWrapper isFirst={isFirst} alignContent={'center'}>
            <TitleWrapper type="secondary" flush textAlign="center">
              <SectionHeader>{title}</SectionHeader>
            </TitleWrapper>
            {descriptions.map((description) => (
              <Description key={description} textAlign="center">
                <Paragraph size={1}>{description}</Paragraph>
              </Description>
            ))}
            <Divider />
          </SectionTextWrapper>
        </div>
      </FeatureStackContentWrapper>
    </Container>
  );
};

export default StackContent;
